import { normalizePathname } from './pathname';

/**
 * 내비게이션 항목의 active 여부를 판정한다 (순수 함수 — 단위 테스트용 export).
 *
 * TRAD-3069 — 원래 `AppSidebar.tsx`에만 있었으나, 상단 내비(`AppTopNav.tsx`)도 같은 판정이
 * 필요해 공유 유틸로 옮겼다. 사이드바가 삭제된 뒤에도(TRAD-3069 4단계) 이 판정 로직은
 * 남아야 하므로 사이드바에 종속되지 않는 위치에 둔다.
 *
 * TRAD-2102 — 운영 인프라가 끝 슬래시로 리다이렉트하므로 `===` 비교 전 정규화한다.
 * (끝 슬래시가 없는 입력에는 항등 함수이므로 기존 동작은 그대로다.)
 */
export const computeIsActive = (rawPathname: string, path: string, allPaths: string[]): boolean => {
  const pathname = normalizePathname(rawPathname);
  if (path === '/') return pathname === '/';
  if (path === '/board/idea') return pathname.startsWith('/board');
  if (pathname === path) return true;
  if (pathname.startsWith(path + '/')) {
    const moreSpecificMatch = allPaths.some(
      (p) => p !== path && p.startsWith(path + '/') && (pathname === p || pathname.startsWith(p + '/')),
    );
    return !moreSpecificMatch;
  }
  return false;
};
